import { render } from "./SymbolsPage.vue?vue&type=template&id=8b68ba42"
import script from "./SymbolsPage.vue?vue&type=script&lang=js"
export * from "./SymbolsPage.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./SymbolsPage.vue?vue&type=style&index=0&id=8b68ba42&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script